const PERSON_TYPE = {
  PHYSICAL: { id: 1, description: 'Pessoa Física' },
  LEGAL: { id: 2, description: 'Pessoa Jurídica' },
  INTERNATIONAL_AGENT: { id: 3, description: 'Agente Internacional' }
};

const PERSON_TYPE_LIST = Object.values(PERSON_TYPE);

const REGISTER_TYPE = {
  EXCHANGE: { id: 1, description: 'Pessoa Física Câmbio Turismo' },
  BASIC_REMITTANCE: { id: 2, description: 'Pessoa Física Básico' },
  COMPLETE_REMITTANCE: { id: 3, description: 'Pessoa Física Completo' },
  LEGAL_PERSON: { id: 4, description: 'Pessoa Jurídica' }
};

const REGISTER_TYPE_LIST = Object.values(REGISTER_TYPE);

const OPERATION_TYPE = {
  REMMITANCE: {
    id: '1',
    description: 'Remessa'
  },
  EXCHANGE: {
    id: '2',
    description: 'Turismo'
  },
  BOTH: {
    id: '3',
    description: 'Ambas'
  }
};

const OPERATION_TYPE_LIST = Object.values(OPERATION_TYPE);

const ENTITY = {
  CUSTOMER: { id: 1, description: 'Cliente' },
  OPERATION: { id: 2, description: 'Operação' },
  BANK: { id: 3, description: 'Banco' },
  STORES: { id: 4, description: 'Lojas' },
  USER: { id: 5, description: 'Usuário' },
  OPERATION_NATURE: { id: 6, description: 'Natureza da Operação' },
  CURRENCY: { id: 7, description: 'Spread / Moeda' }
};

const MUTATIONS = {
  CREATE: { id: 1, description: 'Criação' },
  UPDATE: { id: 2, description: 'Atualização' },
  DELETE: { id: 3, description: 'Deleção' }
};

// eM DESENVOLVIMENTO
const ENTITIES = [
  ENTITY.CUSTOMER,
  ENTITY.OPERATION,
  ENTITY.BANK,
  ENTITY.STORES,
  ENTITY.USER,
  ENTITY.OPERATION_NATURE
];

const ADDRESS_TYPE = {
  RESIDENTIAL: { id: 1, description: 'Residencial' },
  DELIVERY: { id: 2, description: 'Entrega' },
  PROFESSIONAL: { id: 3, description: 'Trabalho' }
};

const ADDRESS_TYPE_LIST = Object.values(ADDRESS_TYPE);

const PROFILES = {
  ADMINISTRATIVE: { id: 1, description: 'Administrador' },
  CORBAN: { id: 2, description: 'Corban' },
  CUSTOMER: { id: 3, description: 'Cliente' }
};

const PROFILES_LIST = Object.values(PROFILES);

const SYSTEM_ACCESS_PROFILES = {
  ADMINISTRATIVE: { id: 1, description: 'Admin' },
  CORBAN: { id: 2, description: 'Corban' },
  CUSTOMER: { id: 3, description: 'Cliente' }
};

const COMMISSION_PAYMENT_ORDER_DOCUMENT_TYPE = {
  NF: {
    id: 1,
    description: 'NF-e'
  },
  PROOF: {
    id: 2,
    description: 'Comprovante de Pagamento'
  }
};

const OPERATIONAL_DOCUMENT_TYPE = {
  INVOICE: { id: 1, description: 'INVOICE' },
  RG_CNH: { id: 2, description: 'RG OU CNH DO RESIDENTE NO EXTERIOR' },
  DI_DUIMP: {
    id: 3,
    description: 'DECLARAÇÃO DE IMP (DI) / DECLARAÇÃO ÚNICA DE IMPORTAÇÃO (DUIMP)'
  },
  CONTRATO_COMPRA_IMOVEL: { id: 4, description: 'CONTRATO DE COMPRA E VENDA DE IMÓVEIS' },
  DOC_APORTE_CAPITAL: { id: 5, description: 'DOCUMENTO APORTE DE CAPITAL' },
  OUTROS: { id: 6, description: 'OUTROS' },
  CONTRATO_ALUGUEL_IMOVEL: { id: 7, description: 'CONTRATO DE ALUGUEL DE IMÓVEIS' },
  CONTRATO_SERVICO_TUR: { id: 8, description: 'CONTRATO DE SERVIÇOS TURÍSTICOS' },
  CONTRATO_SERVICO_EDUC: { id: 9, description: 'CONTRATO DE SERVIÇOS DE EDUCAÇÃO' },
  CONTRATO_SERVICO_JUR: { id: 10, description: 'CONTRATO DE SERVIÇOS JURÍDICOS' },
  CONTRATO_SERVICO_INF: { id: 11, description: 'CONTRATO DE SERVICOS DE INFORMATIC' },
  DOC_DIST_LUCRO: { id: 12, description: 'DOCUMENTO DE DISTRIBUIÇÃO DE LUCROS' },
  COMPROVANTE_CONTA_CONJUNTA: { id: 13, description: 'COMPROVANTE DE CONTA CONJUNTA' },
  FICHA_CADASTRAL: { id: 14, description: 'FICHA CADASTRAL' }
};

const OPERATIONAL_DOCUMENT_TYPE_LIST = Object.values(OPERATIONAL_DOCUMENT_TYPE);

const OTHERS_DOCUMENTS = 7;

const INTEGRATION_PLAYER = {
  OURIBANK: { id: 1, prefix: 'ouribank' },
  EBURY: { id: 2, prefix: 'ebury' },
  BRAZA: { id: 3, prefix: 'brazabank' }
};

/* What an integration player does for the bank linked to it */
const INTEGRATION_TYPE = {
  COMPLETE: {
    id: 1,
    description: 'Integração completa',
    tone: 'info',
    hint: 'Envia o cliente ao banco, abre conta e acompanha limites'
  },
  QUOTATION: {
    id: 2,
    description: 'Cotação integrada',
    tone: 'success',
    hint: 'Cota e fecha o negócio no banco pela tela de operação; cadastro do cliente segue manual'
  }
};

export {
  PERSON_TYPE,
  PERSON_TYPE_LIST,
  REGISTER_TYPE,
  REGISTER_TYPE_LIST,
  OPERATION_TYPE,
  OPERATION_TYPE_LIST,
  ADDRESS_TYPE,
  ADDRESS_TYPE_LIST,
  ENTITIES,
  ENTITY,
  MUTATIONS,
  PROFILES,
  PROFILES_LIST,
  SYSTEM_ACCESS_PROFILES,
  COMMISSION_PAYMENT_ORDER_DOCUMENT_TYPE,
  OPERATIONAL_DOCUMENT_TYPE,
  OPERATIONAL_DOCUMENT_TYPE_LIST,
  OTHERS_DOCUMENTS,
  INTEGRATION_PLAYER,
  INTEGRATION_TYPE
};
